<script>
export default {
  name: "BarcodeScanCard",
  props: {
    scanBlocked: { type: Boolean, default: false },
    barcode: {
      type: String,
      default: ""
    },
    lastScannedBarcode: {
      type: String,
      default: ""
    },
    selectedPartnerLabel: {
      type: String,
      default: ""
    },
    partnerSelectionRequired: {
      type: Boolean,
      default: false
    },
    isExpressMode: {
      type: Boolean,
      default: false
    },
    canReset: {
      type: Boolean,
      default: false
    },
    isComposing: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "scan-key",
    "update:barcode",
    "update:isComposing",
    "scan",
    "open-manual",
    "reset"
  ],
  methods: {
    onBarcodeInput(value) {
      this.$emit("update:barcode", value)
    },
    onEnterScan() {
      this.$emit("scan")
    },
    onSelectClick() {
      this.$emit("scan")
    },
    onOpenManual() {
      this.$emit("open-manual")
    },
    onReset() {
      this.$emit("reset")
    }
  }
}
</script>

<template>
  <div class="comp-box scan-compact" :class="{ 'scan-compact--express': isExpressMode }">
    <div class="row items-center q-mb-sm">
      <div class="col">
        <h6 class="section-title q-mt-none q-mb-none">
          1) {{ isExpressMode ? "상품 바코드 스캔 즉시 처리" : "바코드 스캔" }}
        </h6>
      </div>
      <div class="col-auto">
        <q-badge
          :color="isExpressMode ? 'orange-8' : 'primary'"
          text-color="white"
        >
          {{ isExpressMode ? "익스프레스" : "일반" }}
        </q-badge>
      </div>
    </div>
    <div class="text-caption text-grey-7 q-mb-sm">
      {{
        isExpressMode
          ? "스캔하면 허용 규칙 확인 후 출력과 포장완료를 자동 처리합니다."
          : (selectedPartnerLabel ? `${selectedPartnerLabel} 오더만 조회됩니다.` : "파트너 선택 후 스캔하세요.")
      }}
    </div>
    <div v-if="isExpressMode" class="text-caption text-grey-7 q-mb-sm">
      같은 주문의 중복 출력을 피하도록 한 작업자씩 진행하세요. 출력 결과가 불명확하면 관리자에게 확인하세요.
    </div>
    <q-input
      ref="barcodeInput"
          :readonly="scanBlocked"
          @keydown.capture="$emit('scan-key', $event)"
          @keyup.capture="$emit('scan-key', $event)"
      :model-value="barcode"
      clearable
      autofocus
      label="상품 바코드"
      :disable="partnerSelectionRequired"
      :hint="partnerSelectionRequired ? '먼저 파트너를 선택하세요.' : ''"
      @update:model-value="onBarcodeInput"
      @keyup.enter="onEnterScan"
      @compositionstart="$emit('update:isComposing', true)"
      @compositionend="$emit('update:isComposing', false)"
    >
      <template v-slot:append>
        <q-btn
          :color="isExpressMode ? 'orange-8' : 'primary'"
          :label="isExpressMode ? '즉시 처리' : '선택'"
          :disable="partnerSelectionRequired || scanBlocked"
          @click="onSelectClick"
        />
      </template>
    </q-input>
    <div class="text-caption q-mt-sm">
      최근: <strong>{{ lastScannedBarcode || "-" }}</strong>
    </div>
    <div class="scan-sub-action">
      <q-btn
        flat
        dense
        size="sm"
        color="negative"
        icon="refresh"
        label="초기화"
        :disable="!canReset"
        @click="onReset"
      />
      <q-btn
        flat
        dense
        size="sm"
        color="grey-7"
        icon="manage_search"
        label="수동 조회"
        :disable="partnerSelectionRequired"
        @click="onOpenManual"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-title {
  font-size: 1rem;
  font-weight: 700;
}

.scan-compact {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scan-compact--express {
  border-left: 5px solid #ef6c00;
  background: #fffaf3;
}

.scan-sub-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
}
</style>
